import { render, staticRenderFns } from "./ConsultList.vue?vue&type=template&id=4e4c2de5&scoped=true"
import script from "./ConsultList.vue?vue&type=script&lang=js"
export * from "./ConsultList.vue?vue&type=script&lang=js"
import style0 from "./ConsultList.vue?vue&type=style&index=0&id=4e4c2de5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c2de5",
  null
  
)

export default component.exports